export default [
    {
        path: '/tendero-vip/metricas',
        meta: { nombre: 'Metricas' },
        name: 'tendero-vip.metricas',
        component: () => import(/* webpackChunkName: "informacion" */ '../../pages/metricas').then(m => m.default || m),
    }
]
